import { useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  Provinces,
} from "../../../../../app/slices/provincesSlice";
import { Controller, useForm } from "react-hook-form";
import { HiOutlineMapPin, HiOutlineDocumentText } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../../components/FormDialog";

const CityForm = () => {
  const _SearchBody = useSelector((state) => state.provinces.searchBody);
  const _City = useSelector((state) => state.provinces.cities);
  const _SelectedProvince = useSelector((state) => state.provinces.selectedProvince);

  const isAdd = _City.form.id ? false : true;
  const { control, reset, watch, register, handleSubmit, setValue } = useForm({
    defaultValues: _City.form,
  });

  const onSubmit = (data) => {
    if (isAdd) {
      dispatch(Provinces.create({
        province_id: _SelectedProvince.id,
        name: data.name,
      }, _SearchBody));
    } else {
      dispatch(Provinces.update(data.id, {
        province_id: _SelectedProvince.id,
        name: data.name,
      }, _SearchBody));
    }
  };
  useEffect(() => {
    reset({ ..._City.form });
  }, [_City.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_City.dialog}
      onClose={handleDialog}
      icon={<HiOutlineMapPin />}
      title={isAdd ? "إضافة مدينة" : "تعديل المدينة"}
      subtitle={
        isAdd
          ? "أدخل معلومات المدينة لإضافتها"
          : "قم بتحديث معلومات المدينة ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
    >
      <SectionCard icon={<HiOutlineDocumentText />} title="معلومات المدينة">
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default CityForm;
